// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__nzZ7O","content":"styles_content__2Bza0","selectAll":"styles_selectAll__1rf8Z"};